const path = `/v2/organization/billing/plans`;
const session = Number(Date.now());
const store = require("../../../store");
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  async function get() {
    const response = await repository.get(path);
    return response.data && response.data.subscriptions
      ? response.data.subscriptions
      : {};
  }
  async function getByID({ subscription } = {}) {
    const response = await repository.get(`${path}/${subscription}`);
    return response.data && response.data.subscription
      ? response.data.subscription
      : {};
  }
  async function upgradePlan({ plan } = {}) {
    store.default.commit("pricingRefresh", Date.now());
    const response = await repository.put(`${path}`, {
      plan: plan,
      key: session
    });
    return response.data && response.data.subscription
      ? response.data.subscription
      : {};
  }
  return Object.freeze({
    get,
    getByID,
    upgradePlan
  });
}
